"use strict";
/**
 * @name Input
 *
 * @description
 *  A common input component that will render the appropriate styles.  This currently wraps the 'InputGroup' and 'Input'
 *  styles together.  See the teamsnap patterns library for more inforamtion.
 *    https://teamsnap-ui-patterns.netlify.com/patterns/components/input-group.html
 *    https://teamsnap-ui-patterns.netlify.com/patterns/components/input
 *
 * @example
 *  <Input name='example' type='email' />
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../utils/helpers");
var Icon_1 = require("../Icon");
var Button_1 = require("../Button");
var types_1 = require("../../types");
var statusToColor = {
    warning: 'u-colorWarning',
    error: 'u-colorNegative',
    success: 'u-colorPositive',
};
var propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    size: types_1.Size.PropType,
    leftIcon: PropTypes.node,
    rightIcon: PropTypes.node,
    inputProps: PropTypes.object,
    mods: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    otherProps: PropTypes.object,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.string,
    showStatus: PropTypes.bool,
    showClear: PropTypes.bool,
    onClearClicked: PropTypes.func,
    status: types_1.Status.PropType,
    isDisabled: PropTypes.bool,
    testId: PropTypes.string,
};
var Input = function (_a) {
    var className = _a.className, inputProps = _a.inputProps, leftIcon = _a.leftIcon, mods = _a.mods, id = _a.id, name = _a.name, otherProps = _a.otherProps, placeholder = _a.placeholder, rightIcon = _a.rightIcon, style = _a.style, type = _a.type, size = _a.size, showStatus = _a.showStatus, showClear = _a.showClear, onClearClicked = _a.onClearClicked, status = _a.status, isDisabled = _a.isDisabled, testId = _a.testId;
    var inputClasses = (0, helpers_1.getClassName)(className, leftIcon && 'InputGroup--leftIcon', rightIcon && 'InputGroup--rightIcon', (showStatus || showClear) && 'InputGroup--auxIcon', 'u-flex', mods);
    var inputId = id || name;
    return (React.createElement("div", __assign({ className: inputClasses, style: style, "data-testid": testId }, otherProps),
        leftIcon && React.createElement("div", { className: "InputGroup-icon--left InputGroup-icon" }, leftIcon),
        React.createElement("input", __assign({ disabled: isDisabled, id: inputId, name: name, type: type, placeholder: placeholder, className: "Input " + (size && "Input--" + size) + " " + (isDisabled && 'Input--isDisabled') }, inputProps)),
        rightIcon && React.createElement("div", { className: "InputGroup-icon--right InputGroup-icon" }, rightIcon),
        (showStatus || showClear) && (React.createElement("div", { className: "InputGroup-icon--aux InputGroup-icon" },
            showStatus && !showClear && (React.createElement("span", { className: statusToColor[status] },
                React.createElement(Icon_1.Icon, { name: "info" }))),
            showClear && (React.createElement(Button_1.Button, { type: "link", style: {
                    color: 'inherit',
                    backgroundColor: 'transparent',
                }, className: statusToColor[status] + " InputGroup-icon--clear", onClick: onClearClicked, icon: "dismiss" }))))));
};
Input.defaultProps = {
    children: null,
    className: 'InputGroup',
    inputProps: {},
    mods: null,
    otherProps: {},
    placeholder: '',
    style: {},
    type: 'text',
    testId: null,
};
exports.default = Input;
